import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { EntryPoint } from 'corgi-types';
import type { DisplayProps } from 'styled-system';
import { display, themeGet } from 'styled-system';

import { Flex } from 'common/components/Flex';
import type { ThemeMinHeightProps } from 'common/theme/system-utilities';
import { themeMinHeight } from 'common/theme/system-utilities';
import { TrackingEventName, TrackingPlacement } from '../types';
import Link from './common/Link';
import Text from './common/Text';
import EntryIcon from './EntryIcon';

type EntrypointProps = EntryPoint & DisplayProps;

const Item = styled(Flex)<DisplayProps & ThemeMinHeightProps>`
  ${display};
  ${themeMinHeight};

  &:last-of-type {
    margin-right: ${themeGet('space.sp_0')};
  }
`;

const itemStyles: ComponentProps<typeof Item> = {
  mr: 'sp_32',
  flexDirection: 'row',
  alignItems: 'center',
  themeMinHeight: 'sp_32',
};

const Entrypoint = ({
  icon: { url },
  label,
  labelUrl: { fullUrl, target },
  ...restProps
}: EntrypointProps) => (
  <Item data-testid="entrypoint" {...itemStyles} {...restProps}>
    {fullUrl ? (
      <Link
        href={fullUrl}
        target={target}
        tracking={{
          eventName: TrackingEventName.Click,
          clickedText: label,
          placement: TrackingPlacement.UspBar,
        }}
      >
        <EntryIcon label={label} url={url} />
        {label}
      </Link>
    ) : (
      <Text>
        <EntryIcon label={label} url={url} />
        {label}
      </Text>
    )}
  </Item>
);

export default Entrypoint;
